import classNames from "classnames";
import imgFourStar from "~/assets/images/unified_stars_dashboard_graphics/four_star.svg";
import imgThreeStar from "~/assets/images/unified_stars_dashboard_graphics/three_star.svg";
import imgTwoStar from "~/assets/images/unified_stars_dashboard_graphics/two_star.svg";
import imgOneStar from "~/assets/images/unified_stars_dashboard_graphics/one_star.svg";
import imgZeroStar from "~/assets/images/unified_stars_dashboard_graphics/zero_star.svg";

interface StarRatingProps {
  width: number;
  height: number;
  rating?: number;
  className?: string;
}
export function StarRating(props: StarRatingProps) {
  const ratingGraphic = (rating: number) => {
    switch (rating) {
      case 4:
        return imgFourStar;
      case 3:
        return imgThreeStar;
      case 2:
        return imgTwoStar;
      case 1:
        return imgOneStar;
      default:
        return imgZeroStar;
    }
  };

  const rating = props.rating ? Number(props.rating) : 0;

  return (
    <div
      className={classNames(
        "tw:flex tw:flex-wrap tw:gap-[0.354rem]",
        props.className
      )}
    >
      <img
        src={ratingGraphic(rating)}
        alt="rating"
        width={props.width}
        height={props.height}
      />
    </div>
  );
}
